/* ── Champ générique ───────────────────────────────────────────── */
.field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 0;
}

.fieldInline {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
}

.label {
  font-size: 11px;
  font-weight: 700;
  color: #7a8499;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.labelInline {
  font-size: 14px;
  color: #1a1a2e;
  cursor: pointer;
}

/* Label display-only (type 8) */
.labelDisplay {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
}

/* ── Inputs ────────────────────────────────────────────────────── */
.input,
.select,
.textarea {
  padding: 8px 10px;
  border: 1px solid #dde1e7;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  color: #1a1a2e;
  background: #fff;
  transition: border-color 0.15s;
}

.input:focus,
.select:focus,
.textarea:focus {
  outline: none;
  border-color: #4a6fa5;
  box-shadow: 0 0 0 2px rgba(74, 111, 165, 0.12);
}

.input,
.select     { max-width: 400px; }
.inputNarrow { max-width: 180px; }
.textarea   { min-height: 80px; resize: vertical; max-width: 600px; }

.inputError { border-color: #c0392b !important; }

.maskErrorMsg {
  font-size: 11px;
  color: #c0392b;
}

.checkbox { width: 16px; height: 16px; cursor: pointer; accent-color: #4a6fa5; }

.htmlContent {
  padding: 8px 10px;
  border: 1px solid #dde1e7;
  border-radius: 6px;
  background: #fafbfc;
  font-size: 14px;
  max-width: 600px;
}

/* ── Boutons ───────────────────────────────────────────────────── */
.btnPrimary {
  padding: 8px 20px;
  font-size: 14px;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  background: #4a6fa5;
  color: #fff;
  cursor: pointer;
  align-self: flex-start;
}
.btnPrimary:hover { background: #3a5f95; }

.btnSmall {
  align-self: flex-start;
  padding: 4px 12px;
  font-size: 12px;
  border: 1px solid #dde1e7;
  border-radius: 4px;
  background: #f5f5f7;
  cursor: pointer;
  color: #5a6270;
  font-family: inherit;
}
.btnSmall:hover { background: #e8eaed; }
.btnSmall:disabled { opacity: 0.4; cursor: default; }

/* ── Canvas ────────────────────────────────────────────────────── */
.canvas {
  border: 1px solid #dde1e7;
  border-radius: 6px;
  background: #fff;
  cursor: crosshair;
  display: block;
  max-width: 100%;
}

/* ── Combo ajax ────────────────────────────────────────────────── */
.comboWrapper { position: relative; max-width: 400px; }

.comboDropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 100;
  background: #fff;
  border: 1px solid #dde1e7;
  border-top: none;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  list-style: none;
  margin: 0;
  padding: 4px 0;
  max-height: 200px;
  overflow-y: auto;
}

.comboItem {
  padding: 8px 12px;
  font-size: 14px;
  color: #1a1a2e;
  cursor: pointer;
}
.comboItem:hover { background: #f0f2f5; }
.comboItemEmpty { color: #888; cursor: default; font-style: italic; }
.comboItemEmpty:hover { background: none; }

/* ── TanStack Table — Card wrapper ─────────────────────────────── */
.tableCard {
  border: 1px solid #dde1e7;
  border-radius: 0.1rem;
  background: #fff;
  overflow: hidden;
  margin-bottom: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}

/* ── TanStack Table — Toolbar ──────────────────────────────────── */
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 10px;
  border-bottom: 1px solid #dde1e7;
  background: #f7f9fc;
  flex-wrap: wrap;
}
.toolbarLeft, .toolbarRight { display: flex; align-items: center; gap: 2px; }

.toolbarLabel { font-size: 12px; color: #7a8499; white-space: nowrap; }

.toolbarSelect {
  padding: 4px 8px;
  border: 1px solid #dde1e7;
  border-radius: 0.1rem;
  font-size: 12px;
  font-family: inherit;
  color: #1a1a2e;
  background: #fff;
  cursor: pointer;
}

.toolbarBtn {
  padding: 4px 6px;
  font-size: 12px;
  font-family: inherit;
  border: 1px solid #dde1e7;
  border-radius: 0.1rem;
  background: #f5f5f7;
  color: #5a6270;
  cursor: pointer;
  white-space: nowrap;
}
.toolbarBtn:hover { background: #e8eaed; }

.toolbarBtnExport {
  padding: 4px 6px;
  font-size: 12px;
  font-family: inherit;
  border: 1px solid #b0c8e8;
  border-radius: 0.1rem;
  background: #e8f0fb;
  color: #2c4a7c;
  cursor: pointer;
  white-space: nowrap;
}
.toolbarBtnExport:hover { background: #d0e2f7; }

.toolbarBtnAdd {
  padding: 4px 6px;
  font-size: 12px;
  font-family: inherit;
  border: 1px solid #9ecfb0;
  border-radius: 0.1rem;
  background: #e6f4ec;
  color: #1e6b3a;
  cursor: pointer;
  white-space: nowrap;
}
.toolbarBtnAdd:hover { background: #d0ecda; }

.toolbarBtnDelete {
  padding: 4px 6px;
  font-size: 12px;
  font-family: inherit;
  border: 1px solid #f0b8b8;
  border-radius: 0.1rem;
  background: #fdecea;
  color: #9b2020;
  cursor: pointer;
  white-space: nowrap;
}
.toolbarBtnDelete:hover:not(:disabled) { background: #fad8d5; }
.toolbarBtnDelete:disabled { opacity: 0.38; cursor: default; }

.toolbarSep {
  display: inline-block;
  width: 1px;
  height: 20px;
  background: #dde1e7;
  margin: 0 4px;
  align-self: center;
}

.colPanel {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 200;
  background: #fff;
  border: 1px solid #dde1e7;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.10);
  padding: 8px 0;
  min-width: 160px;
  max-height: 280px;
  overflow-y: auto;
}
.colPanelItem {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 14px;
  font-size: 13px;
  color: #1a1a2e;
  cursor: pointer;
  white-space: nowrap;
}
.colPanelItem:hover { background: #f0f4f9; }
.colPanelReset {
  display: block;
  width: 100%;
  text-align: left;
  padding: 5px 14px;
  margin-bottom: 4px;
  font-size: 13px;
  color: hsl(var(--destructive));
  background: none;
  border: none;
  border-bottom: 1px solid #eef1f5;
  cursor: pointer;
}
.colPanelReset:hover { background: #f0f4f9; }

/* ── TanStack Table — Wrapper & Table ──────────────────────────── */
.tableScroll {
  overflow-x: auto;
  overflow-y: auto;
}

.tbl {
  border-collapse: collapse;
  background: #fff;
  table-layout: fixed;
}

.thSpacer {
  position: sticky;
  top: 0;
  z-index: 2;
  background: hsl(var(--muted));
  border-bottom: 2px solid hsl(var(--muted-border));
}

.tdSpacer {
  padding: 0;
  border: none;
}

/* ── Headers ───────────────────────────────────────────────────── */
.th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: hsl(var(--muted));
  border-bottom: 2px solid hsl(var(--muted-border));
  border-right: 1px solid #e4e8ef;
  padding: 0;
  vertical-align: top;
  white-space: nowrap;
  box-sizing: border-box;
  transition: background 0.15s;
}
.th:last-child { border-right: none; }
.th:hover { background: hsl(var(--muted-hover)); }
.th:hover .thInner { color: hsl(var(--primary)); }

/* En-tête de groupement de colonnes (attribut JSON `children`) — chapeaute plusieurs colonnes
   feuilles via colSpan, jamais triable/filtrable. Redimensionnable via .resizer (voir
   getRightmostLeafHeader) : équivalent à redimensionner sa dernière colonne feuille, dont le bord
   droit coïncide avec le sien. Note : le sticky top:0 ne reste correct que pour la 1re ligne
   d'en-tête ; une 2e ligne de feuilles imbriquées sous un groupe défilerait sous elle plutôt que
   de rester également figée (limitation connue). */
.thGroup {
  position: sticky;
  top: 0;
  z-index: 2;
  background: hsl(var(--muted));
  border-bottom: 2px solid hsl(var(--muted-border));
  border-right: 1px solid hsl(var(--muted-border));
  padding: 6px 10px;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  color: #7a8499;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-sizing: border-box;
}
.thGroup:last-child { border-right: none; }

.thInner {
  padding: 7px 10px 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  color: #7a8499;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 0;
}

/* Libellé d'en-tête (colonne feuille ou groupe) — tronqué avec ellipsis plutôt que de déborder
   sur les colonnes voisines ; `min-width: 0` nécessaire pour autoriser le rétrécissement dans la
   chaîne de conteneurs flex imbriqués (.thInner > .sortable > span icône+libellé > .thLabel). */
.thLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.sortable {
  cursor: pointer;
  user-select: none;
}

.thFilter {
  display: block;
  width: calc(100% - 16px);
  margin: 0 8px 6px;
  padding: 3px 6px;
  border: 1px solid #dde1e7;
  border-radius: 0.1rem;
  font-size: 11px;
  font-family: inherit;
  color: #1a1a2e;
  background: #fff;
  box-sizing: border-box;
}
.thFilter:focus { outline: none; border-color: #4a6fa5; }

.thFilterBtn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: calc(100% - 16px);
  margin: 0 8px 6px;
  padding: 3px 6px;
  border: 1px solid #dde1e7;
  border-radius: 0.1rem;
  font-size: 11px;
  font-family: inherit;
  color: #1a1a2e;
  background: #fff;
  box-sizing: border-box;
  cursor: pointer;
  text-align: left;
}
.thFilterBtn:hover { border-color: #4a6fa5; }
.thFilterBtnActive { border-color: #4a6fa5; background: #f0f4fa; }

.thFilterDropdown {
  position: absolute;
  top: 100%;
  left: 8px;
  z-index: 200;
  background: #fff;
  border: 1px solid #dde1e7;
  border-radius: 0.25rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  max-height: 200px;
  overflow-y: auto;
  padding: 4px 0;
  min-width: 140px;
}
.thFilterOption {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  font-size: 11px;
  cursor: pointer;
  color: #1a1a2e;
  user-select: none;
}
.thFilterOption:hover { background: #f5f7fb; }
.thFilterEmpty { padding: 6px 10px; font-size: 11px; color: #888; font-style: italic; }

.resizer {
  position: absolute;
  top: 0;
  right: 0;
  width: 5px;
  height: 100%;
  cursor: col-resize;
  user-select: none;
  touch-action: none;
}
.resizer:hover, .resizerActive { background: #4a6fa5; opacity: 0.5; }

/* ── Rows & Cells ──────────────────────────────────────────────── */
.tr { transition: background 0.1s; }
.tr:nth-child(odd)  .td { background: #ffffff; }
.tr:nth-child(even) .td { background: #f3f7fc; }
.tr:hover .td { background: #e0eaf7; }

.trGrouped .td {
  background: #edf2fa;
  font-weight: 600;
  color: #2c4a7c;
  border-bottom: 1px solid #c8d5e8;
}

.trSelected .td {
  background: #e0eaf7 !important;
  color: #2c4a7c;
  font-weight: 600;
}

.trParent .td { background: #f7f9fc; font-weight: 600; }
.trLeaf:hover .td  { background: #e0eaf7; cursor: pointer; }

.td {
  padding: 6px 10px;
  border-bottom: 1px solid #f0f2f5;
  border-right: 1px solid #f0f2f5;
  font-size: 13px;
  color: #1a1a2e;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.td:last-child { border-right: none; }

.tdMsg {
  padding: 20px;
  text-align: center;
  color: #7a8499;
  font-size: 13px;
  font-style: italic;
}

/* Sticky locked columns */
.thLocked { border-right: 2px solid #b8c8df !important; }
.tdLocked { border-right: 2px solid #d0dcec !important; }

/* ── Footer ─────────────────────────────────────────────────────── */
.tfootTr { background: #f0f4f9; }
.tfootTd {
  position: sticky;
  bottom: 0;
  z-index: 2;
  padding: 6px 10px;
  font-size: 13px;
  font-weight: 700;
  color: #2c4a7c;
  background: #f0f4f9;
  border-top: 2px solid #dde1e7;
  border-right: 1px solid #e4e8ef;
  text-align: right;
}
.tfootTd:last-child { border-right: none; }

/* ── Inline cell editors ────────────────────────────────────────── */
.cellInput {
  width: 100%;
  padding: 3px 6px;
  border: 1px solid transparent;
  border-radius: 0.1rem;
  font-size: 13px;
  font-family: inherit;
  background: transparent;
  color: #1a1a2e;
  box-sizing: border-box;
}
.cellInput:focus    { outline: none; border-color: #4a6fa5; background: #fff; }
.cellInputRight     { text-align: right; }
.cellSelect         { font-size: 13px; font-family: inherit; border: none; background: transparent; color: #1a1a2e; cursor: pointer; width: 100%; }
.cellSelect:focus   { outline: 1px solid #4a6fa5; }
.cellInputErr       { border-color: #c0392b !important; background: #fff5f5 !important; }

/* ── Expand / Group buttons ─────────────────────────────────────── */
.expandBtn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: inherit;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}
.groupCount { font-size: 11px; color: #7a8499; font-weight: 400; }
/* Cellule d'agrégat par colonne sur une ligne de groupement (summaryType, calculé sur les lignes
   feuilles du groupe — cf. TableField.jsx/TreeField.jsx) — alignement à droite comme le pied de
   tableau (.tfootTd), sans son positionnement sticky (n'a pas lieu d'être dans <tbody>). */
.groupAggTd { text-align: right; }

.treeExpandBtn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 10px;
  color: #4a6fa5;
  padding: 2px 4px;
  line-height: 1;
  flex-shrink: 0;
}
.treeExpandBtn:hover { color: #2c4a7c; }
.treeLeafDot { font-size: 8px; color: #c0c8d8; padding: 0 4px; flex-shrink: 0; }

/* ── Pagination ─────────────────────────────────────────────────── */
.paginationBar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-top: 1px solid #dde1e7;
  background: #f7f9fc;
  flex-wrap: wrap;
}
.pageBtn {
  padding: 4px 10px;
  font-size: 13px;
  font-family: inherit;
  border: 1px solid #dde1e7;
  border-radius: 0.1rem;
  background: #fff;
  color: #4a6fa5;
  cursor: pointer;
}
.pageBtn:hover:not(:disabled) { background: #f0f4f9; }
.pageBtn:disabled { opacity: 0.35; cursor: default; }
.pageInfo { font-size: 12px; color: #7a8499; padding: 0 4px; }
.pageSizeSelect {
  padding: 3px 6px;
  font-size: 12px;
  font-family: inherit;
  border: 1px solid #dde1e7;
  border-radius: 0.1rem;
  background: #fff;
  color: #5a6270;
  margin-left: auto;
}

/* ── Onglets ───────────────────────────────────────────────────── */
.tabs { border: 1px solid #dde1e7; border-radius: 8px; background: #fff; overflow: hidden; }

.tabButtons { display: flex; border-bottom: 1px solid #dde1e7; background: #f5f5f7; }

.tabBtn {
  padding: 10px 20px;
  border: none;
  border-bottom: 2px solid transparent;
  background: none;
  font-size: 13px;
  font-family: inherit;
  color: #7a8499;
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
}
.tabBtn:hover { color: #1a1a2e; }

.tabBtnActive { color: #4a6fa5; font-weight: 600; border-bottom-color: #4a6fa5; background: #fff; }

.tabContent { padding: 20px; }

/* ── Collapse bar ───────────────────────────────────────────────── */
.collapseBar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  background: hsl(var(--muted));
  user-select: none;
}
.collapseBar:hover { background: hsl(var(--accent)); }
.collapseBarExpanded { border-bottom: 1px solid #dde1e7; }
.collapseBarLabel {
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  color: #2c4a7c;
}

/* ── Row number column ──────────────────────────────────────────── */
.rowNumTh {
  position: sticky;
  top: 0;
  z-index: 2;
  background: hsl(var(--muted));
  border-bottom: 2px solid hsl(var(--muted-border));
  border-right: 1px solid #e4e8ef;
  font-size: 10px;
  font-weight: 700;
  color: #b0b8c9;
  text-align: right;
  padding: 0 6px;
  white-space: nowrap;
  box-sizing: border-box;
}
.rowNumTd {
  color: #b0b8c9 !important;
  font-size: 11px !important;
  text-align: right !important;
  padding: 6px 8px !important;
  white-space: nowrap;
  user-select: none;
  border-right: 1px solid #f0f2f5 !important;
}

/* ── Drag handle column ─────────────────────────────────────────── */
.dragHandleTh {
  position: sticky;
  top: 0;
  z-index: 2;
  background: hsl(var(--muted));
  border-bottom: 2px solid hsl(var(--muted-border));
  border-right: 1px solid #e4e8ef;
  box-sizing: border-box;
}
.dragHandleTd {
  padding: 0 !important;
  text-align: center;
  border-right: 1px solid #f0f2f5;
  box-sizing: border-box;
  vertical-align: middle;
}
.dragHandle {
  display: block;
  color: #c0c8d8;
  font-size: 15px;
  line-height: 1;
  padding: 6px 4px;
  cursor: grab;
}
.dragHandle:active { cursor: grabbing; }

/* ── Drag & drop visual feedback ────────────────────────────────── */
/* position "append" — dépose comme enfant / ajout en fin de liste */
.trDragOver > .td,
.trDragOver > .dragHandleTd,
.trDragOver > .rowNumTd {
  background: #dbeafe !important;
  outline: none;
}
.trDragOver {
  outline: 2px solid #4a6fa5;
  outline-offset: -1px;
}
/* position "before" / "after" — insertion au-dessus / en-dessous de la ligne */
.trDragOverBefore {
  box-shadow: inset 0 2px 0 0 #4a6fa5;
}
.trDragOverAfter {
  box-shadow: inset 0 -2px 0 0 #4a6fa5;
}
.dropZoneTd {
  height: 6px;
  padding: 0 !important;
  background: transparent;
  border: none !important;
}

/* ── Splitter (CanvasField, attribut `splitter`) ──────────────────── */
/* Dégradé clair→foncé→clair + box-shadow inset (highlight/ombre sur chaque bord) : simule un
   biseau/relief plutôt qu'un aplat — même principe qu'un grip physique. Orientation de la barre
   (`col`/`row`) déterminée par le sens de la barre elle-même (verticale → panneaux en ligne),
   perpendiculaire à l'axe de drag. */
.splitterBarCol {
  background: linear-gradient(to right, hsl(var(--border)) 0%, hsl(var(--muted)) 50%, hsl(var(--border)) 100%);
  box-shadow: inset 1px 0 0 rgba(255,255,255,.5), inset -1px 0 0 rgba(0,0,0,.18);
}
.splitterBarCol:hover, .splitterBarCol:active {
  background: linear-gradient(to right, hsl(var(--border)) 0%, hsl(var(--accent)) 50%, hsl(var(--border)) 100%);
}
.splitterBarRow {
  background: linear-gradient(to bottom, hsl(var(--border)) 0%, hsl(var(--muted)) 50%, hsl(var(--border)) 100%);
  box-shadow: inset 0 1px 0 rgba(255,255,255,.5), inset 0 -1px 0 rgba(0,0,0,.18);
}
.splitterBarRow:hover, .splitterBarRow:active {
  background: linear-gradient(to bottom, hsl(var(--border)) 0%, hsl(var(--accent)) 50%, hsl(var(--border)) 100%);
}
.splitterGrip {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: hsl(var(--muted-foreground));
  pointer-events: none;
}
